import {
  Box,
  Button,
  Image,
  Link,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { Product } from "../../interfaces/Config";
import { Channel } from "../../interfaces/tracking";
import { camelize } from "../../utils/developmentUtils";
import { Analytics, EventNames } from "../../utils/tracking";
import CustomModal from "../CustomModal/CustomModal";

interface ProductBannerOnColorVTOProps {
  product: Product;
  color: string;
}

export const ProductBannerOnColorVTO: React.FC<ProductBannerOnColorVTOProps> = (
  props
) => {
  const { product, color } = props;
  const { isOpen: isOpen, onOpen: onOpen, onClose: onClose } = useDisclosure();
  const platform: string =
    new URLSearchParams(window.location.search).get("platform") ?? "";

  const onLinkClick = () => {
    Analytics.event(Channel.TEALIUM, EventNames.SELECT_CONTENT, {
      page_name: "hair color try on",
      page_type: "virtual try-on",
      page_group: "virtual try-on",
      component_title: product.buttonLabel,
      action_type: "link",
      action_label: product.buttonLabel,
      tryon_hair_color: color,
    });
    onClose();
  };
  return (
    <Box
      display={{ base: "flex", md: "flex" }}
      width={{ base: "390px", md: "571px" }}
      height={{ base: "121px", md: "204px" }}
      padding={{ base: "13px 24px 11px 24px", md: "10px 24px" }}
      alignItems={{ base: "flex-start", md: "center" }}
      gap={{ base: "10px", md: "24px" }}
    >
      <Image
        width={{ base: "86px", md: "180px" }}
        height={{ base: "93px", md: "172px" }}
        src={
          product.imageUrl.startsWith("http")
            ? product.imageUrl
            : `${process.env.PUBLIC_URL}/assets/images/${product.imageUrl}`
        }
      />
      <Box
        display={{ base: "flex", md: "flex" }}
        height={{ md: "171px" }}
        flexDirection={{ base: "column", md: "column" }}
        justifyContent={{ md: "flex-end" }}
        alignItems={{ base: "flex-start", md: "flex-start" }}
        gap={{ base: "8px", md: "24px" }}
        flexShrink={{ md: "0" }}
      >
        <Box
          display={{ base: "flex", md: "flex" }}
          flexDirection={{ base: "column", md: "column" }}
          alignItems={{ base: "start", md: "start" }}
          gap={{ base: "3.53px", md: "16px" }}
        >
          <Text
            color={{ base: "#6E6E6E" }}
            textAlign={{ base: "center", md: "center" }}
            fontFamily={{ base: "Circular Std", md: "Circular Std" }}
            fontSize={{ base: "14px", md: "20px" }}
            fontStyle={{ base: "normal", md: "normal" }}
            fontWeight={{ base: "normal" }}
            lineHeight={{ base: "17px" }}
            letterSpacing={{ base: "0.265px", md: "0.265px" }}
          >
            {camelize(product.brandName)}
          </Text>
          <Text
            color={{ base: "#000", md: "#000" }}
            textAlign={{ base: "center", md: "center" }}
            fontFamily={{ base: "Circular Std", md: "Circular Std" }}
            fontSize={{ base: "14px", md: "20px" }}
            fontStyle={{ base: "normal", md: "normal" }}
            fontWeight={{ base: "normal" }}
            lineHeight={{ base: "17px" }}
            letterSpacing={{ base: "0.265px", md: "0.265px" }}
          >
            {camelize(product.productName)}
          </Text>
          <Text
            color={{ base: "#000", md: "#000" }}
            fontFamily={{ base: "Circular Std", md: "Circular Std" }}
            fontSize={{ base: "14px", md: "20px" }}
            fontStyle={{ base: "normal", md: "normal" }}
            fontWeight={{ base: "normal" }}
            lineHeight={{ base: "17px" }}
            letterSpacing={{ base: "0.265px", md: "0.265px" }}
          >
            Color: {product.colorName}
          </Text>
        </Box>
        {platform.includes("g-mob") ? (
          <Button
            display={{ base: "flex", md: "flex" }}
            height={{ base: "33.529px", md: "49.412px" }}
            padding={{ base: "10.588px 21.176px", md: "14.118px 28.235px" }}
            justifyContent={{ base: "center", md: "center" }}
            alignItems={{ base: "center", md: "center" }}
            gap={{ base: "7.059px", md: "7.059px" }}
            onClick={onOpen}
            flexShrink={{ md: "0" }}
            _hover={{ bg: "transparent" }}
            border={
              "1px solid var(--Component-Category-Tokens-button-secondary-secondary-border, #000)"
            }
            background={
              "var(--Component-Category-Tokens-button-secondary-secondary-bg, #FFF)"
            }
          >
            <Text
              color={
                "var(--Component-Category-Tokens-button-secondary-secondary-content, #000)"
              }
              fontFamily={{ base: "Circular Std", md: "Circular Std" }}
              fontSize={{ base: "10.558", md: "12.353px" }}
              fontStyle={{ base: "normal", md: "normal" }}
              fontWeight={{ base: "500", md: "500" }}
              lineHeight={{ base: "14.118px", md: "21.176px" }}
              letterSpacing={{ base: "1.147px", md: "1.147px" }}
              textTransform={{ base: "uppercase", md: "uppercase" }}
            >
              {product.buttonLabel}
            </Text>
          </Button>
        ) : (
          <Link href={product.detailsUrl} onClick={onLinkClick} isExternal>
            <Button
              display={{ base: "flex", md: "flex" }}
              height={{ base: "33.529px", md: "49.412px" }}
              padding={{ base: "10.588px 21.176px", md: "14.118px 28.235px" }}
              justifyContent={{ base: "center", md: "center" }}
              alignItems={{ base: "center", md: "center" }}
              gap={{ base: "7.059px", md: "7.059px" }}
              _hover={{ bg: "transparent" }}
              flexShrink={{ md: "0" }}
              border={
                "1px solid var(--Component-Category-Tokens-button-secondary-secondary-border, #000)"
              }
              background={
                "var(--Component-Category-Tokens-button-secondary-secondary-bg, #FFF)"
              }
            >
              <Text
                color={
                  "var(--Component-Category-Tokens-button-secondary-secondary-content, #000)"
                }
                fontFamily={{ base: "Circular Std", md: "Circular Std" }}
                fontSize={{ base: "10.558", md: "12.353px" }}
                fontStyle={{ base: "normal", md: "normal" }}
                fontWeight={{ base: "500", md: "500" }}
                lineHeight={{ base: "14.118px", md: "21.176px" }}
                letterSpacing={{ base: "1.147px", md: "1.147px" }}
                textTransform={{ base: "uppercase", md: "uppercase" }}
              >
                {product.buttonLabel}
              </Text>
            </Button>
          </Link>
        )}
      </Box>
      <CustomModal
        isOpen={isOpen}
        onClose={onClose}
        href={product.detailsUrl}
        onClick={onLinkClick}
        isExternal={true}
        title="You are about to leave this experience"
        body="To explore again, please visit the Discover tab"
        titleBtnConfirm="OK"
        titleBtnCancel="Cancel"
        showIcon={true}
      />
    </Box>
  );
};
